
    import { Checkbox } from '@alifd/next';
    import type { CheckboxProps } from '@alifd/next/types/checkbox';
    import wrapper from './next-wrapper';

    export type BLProFormCheckboxProps =CheckboxProps;

    const BLProFormCheckbox = wrapper<BLProFormCheckboxProps>(Checkbox, 'BLProFormCheckbox');

    export default BLProFormCheckbox;
